import React from 'react';
import PropTypes from 'prop-types';
import LawberryLogo from '../images/lawberry-logo_on_black.svg';
import SecretarLogo from '../images/secretar_logo_on_black.png';


let logo = LawberryLogo;
if (window.location.hostname === 'secretar.me' || window.location.hostname === 'www.secretar.me' || window.location.hostname === 'secretar' || window.location.hostname === 'localhost') {
  logo = SecretarLogo;
}


const SimpleAppBar = ({ userComponent }) => (
  <div>
    <img
      src={logo}
      style={{ marginTop: '7px', marginLeft: '13px' }}
      height={25}
      // alt="Secretar logo"
    />
    {userComponent}
  </div>
);

SimpleAppBar.defaultProps = {
  userComponent: null
};

SimpleAppBar.propTypes = {
  userComponent: PropTypes.shape({ logout: PropTypes.func })
};

export default SimpleAppBar;



// WEBPACK FOOTER //
// ./src/components/TopBar.js